import { HCO_CUBE_NAME } from '@/api/hco/constants';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { HCO_SPECIALTY_FILTER_LIMIT } from '../../filterDefaultLimits';

const HCO_SPECIALTY_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.specialty`],
  limit: HCO_SPECIALTY_FILTER_LIMIT,
});

const hcoSpecialtyFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcoSpecialtyLabel',
  placeholder: 'global.filters.formControls.hcoSpecialtyPlaceholder',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  applyDynamicFilters: true,
  sourceCube: HCO_CUBE_NAME,
  getOptionsQuery: HCO_SPECIALTY_OPTIONS,
  mapResult: mapDimensionToOption(`${HCO_CUBE_NAME}.specialty`),
  applyFilter: value => {
    const selected = Array.isArray(value) ? value.map(String) : [];
    if (selected.length === 0) return undefined;
    return {
      member: `${HCO_CUBE_NAME}.specialty`,
      operator: 'equals',
      values: selected,
    };
  },
};

export default hcoSpecialtyFilter;
